import { CSSProperties } from 'react';

// 16:9, matches the previous hardcoded embed16by9 behavior for video links
export const DEFAULT_VIDEO_RATIO = 0.5625;

const MAX_VIDEO_HEIGHT = '70vh';

/**
 * Sizes a video container from its aspect ratio (height / width).
 * Portrait videos would otherwise fill the column width and tower over the page —
 * cap the height and let the width shrink to keep the aspect ratio.
 */
export const videoContainerStyle = (ratio: number): CSSProperties => ({
  aspectRatio: `1 / ${ratio}`,
  maxWidth: `min(100%, calc(${MAX_VIDEO_HEIGHT} / ${ratio}))`,
});
